<template>
    <div id="app">
        <div class="center">
            <CodeMatrix :seed="seed"/>
            Shareable Link (<a :href="shareable_link" class="copy_link">Copy</a>):<br>
            <input type="text" class="shareable_input" :value="shareable_link"/><br>
            <button type="button" class="shuffle">Shuffle</button>
            <div class="instructions">
                <p>
                    This is a Code Generator for playing the game <a href="https://www.spiel-des-jahres.de/spiele/codenames/">Codenames</a> online.
                </p>
                <ol>
                    <li>One of the team leaders goes to this site and presses the shuffle button a few times to generate a new random pattern.</li>
                    <li>Then he or she shares the link, but only with the opponent team's leader.</li>
                    <li>Both team leaders now have a common view on the secret code and can start playing by the normal game rules.</li>
                    <li>Use a video chat and have one player point their camera at a 5x5-matrix of word cards from the original game.</li>
                </ol>
                <p>
                    Note: If you don't trust the team leaders or the game master not to cheat, don't play with them.
                    Very paranoid, crypto-affine players may chose to have the random defined by some external trusted source of randomness.
                    However, this won't prevent them from leaking the code to their team members by some other channel either.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import CodeMatrix from './components/CodeMatrix.vue'

    function fallbackCopyTextToClipboard(text) {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            const successful = document.execCommand('copy');
            const msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }

    function copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function() {
            console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
    }

    export default {
        name: 'App',
        components: {
            CodeMatrix
        },
        data () {
            const seed = this.retrieveSeed();
            return {
                seed: seed
            };
        },
        methods: {
            retrieveSeed() {
                let seed = window.location.hash;
                if (seed.length < 2) {
                    seed = '1234'
                }
                seed = seed.substr(1);
                return seed;
            },
            updateHash() {
                console.log("updateHash");
                this.seed = this.retrieveSeed();
            },
            shuffle() {
                console.log("shuffling");
                window.location.hash = "#" + Math.round(Math.abs(new Math.seedrandom().int32() / 10000));
            }
        },
        computed: {
            shareable_link() {
                return location.protocol + '//' + location.host + location.pathname + location.search + '#' + this.seed;
            }
        },
        beforeMount() {
            console.log("before mount");
            const self = this;
            window.onhashchange = function () {
                console.log("updateHash");
                self.seed = self.retrieveSeed();
            };
        },
        mounted() {
            const self = this;
            document.querySelector('.copy_link').addEventListener('click', function(event) {
                copyTextToClipboard(self.shareable_link);
            });
            document.querySelector('.shuffle').addEventListener('click', function(event) {
                self.shuffle();
            });
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }

    .matrix td {
        border: 1px solid black;
        padding: 10px;
        width: 40px;
        height: 40px;
    }

    .center {
        width: 400px;
        margin-left: auto;
        margin-right: auto;
    }

    .shareable_input {
        width: 200px;
        padding: 5px;
        margin: 3px;
    }

    .copy_link:visited {
        color: blue;
    }

    button {
        height: 40px;
        min-width: 120px;
    }

    .instructions {
        margin-top: 50px;
        font-size: small;
        li {
            margin-top: 5px;
        }

    }
</style>
